module.exports = __webpack_public_path__ + "img/impact2.6e519405.jpg";